<template>
  <v-card class="flex col text-start" :class="{ white }" flat>
    <AppLink :to="url" plain>
      <AppImg :src="getFeaturedImageSrc(post, 'large')" :alt="post.title.rendered" />
    </AppLink>
    <AppLink :to="url">
      <v-card-title class="px-6 pt-3 pb-0" v-html="post.title.rendered" />
    </AppLink>
    <v-card-subtitle class="px-6 pt-3 pb-4">
      {{ date }} • {{ getAuthorName(post) }}
    </v-card-subtitle>
    <v-card-text v-if="hasExcerpt" class="mx-6 pt-4 pb-0 px-0" v-html="post.excerpt.rendered" />
    <v-card-actions class="flex justify-end px-6 mt-6">
      <AppLink :to="url" plain>
        {{ $tt('blog.read_more') }}
        <ChevronMarker dir="next" size="x-large" class="text-primary" />
      </AppLink>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import type { BlogPost } from '~/types';
import { getAuthorName, getFeaturedImageSrc } from '~/helpers/blog';
import { buildArticlePath } from '~/helpers/routing';

const props = defineProps<{
  post: BlogPost;
  hasExcerpt?: boolean;
  white?: boolean;
}>();

const { formatDate } = useFormat();
const date = formatDate(props.post.date);
const url = buildArticlePath(props.post.slug);

const imgHeight = (props.hasExcerpt && !props.white) ? '280px' : '200px';
</script>

<style scoped>
.v-card {
  background: #F7F7F7;
  border-radius: var(--border-r-md);
}
img {
  height: v-bind(imgHeight);
  min-width: 100%;
  object-fit: cover;
  border-radius: var(--border-r-md);
}
.v-card-title, .v-card-actions {
  font-size: 20px;
  line-height: var(--lh-md) !important;
}
.v-card-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.v-card-subtitle {
  opacity: 1;
}
:deep(p), div {
  font-size: 16px;
  margin-bottom: 0;
}
.v-card-text {
  border-top: 1px solid #828282;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  line-clamp: 8;
  -webkit-box-orient: vertical;
}
.v-card-actions {
  border-top: 1px solid #828282;
}
.v-card-title, .v-card-text {
  div {
    box-sizing: border-box;
  }
}
.white {
  max-width: 360px;
  box-shadow: 0px 8px 18px rgba(0, 0, 0, .2);
  .v-card {
    background: #fff;
  }
  a:hover {
    color: rgb(var(--v-theme-primary));
    text-decoration: underline;
  }
}

@media (max-width: 850px) {
  .white {
    max-width: calc(100vw - (2 * var(--space-4)));
  }  
}
</style>